const ca = `-----BEGIN CERTIFICATE-----
MIIFfTCCA2WgAwIBAgIUS2gTXPpIJZPCIawyS+L9WU6YWGUwDQYJKoZIhvcNAQEL
BQAwTjELMAkGA1UEBhMCVUsxDzANBgNVBAgMBkxvbmRvbjEVMBMGA1UECgwMVGhh
bGFtb3MgTHRkMRcwFQYDVQQDDA50aGFsYW1vcy5jby51azAeFw0yNDAyMjIxMDM5
MThaFw0zNDAyMTkxMDM5MThaME4xCzAJBgNVBAYTAlVLMQ8wDQYDVQQIDAZMb25k
b24xFTATBgNVBAoMDFRoYWxhbW9zIEx0ZDEXMBUGA1UEAwwOdGhhbGFtb3MuY28u
dWswggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQC8EpYT/cWRoy5gLkLa
qIaI9yYLMnwF0vtYrYVdy3ordoZ2BnGIBgyhyAwG5KdX2Ip2Z+/HZEt8Oj1v9AET
Ju3IKIOUf2QyOTjzH37/RCbJex+BU25cSkQch1Z81uBfdmRSX+r74KoIS9ENjIF0
efjRafCabFpRLjrqPJeeoHAjkCsjLaQEEF+nzWFuwpoyULy2bA5/JFfgtRKNY3A8
UbemPyKimj+UEcGIZiAXyUhKislMhyDk55semCp/mGQ4u+MvdQ30pdUq6tR4RUIg
ySxxkgkrUuGOFpVANiC/cxcln6LCYX5o4TxbfgtyTccHdcX4B/UZ3lu9DYYK5E89
pSl5C3aOTqZLZnSJcdUyu7YcWSo2TTDjp2yMAmJGFbvJQRZumm24a14Czb48pTK9
LmvBPxzRiDb3O7rhNKc8daQ0m2eUg6hP5/BA8wRdciSf23jhhgTWKI718U7XKXEg
B2r0L3oS1j9f6B4KYOPxGRCtijzzSffFkJxVyfBNjzb76wuvm1hRu+7pPfirkiPn
CUfNTih96BuKlTButZN5oMdsKK2tfccnyreIpsI8x0x6sGZx8ynSrvDkELeoJx30
WX93240mpM+kjHzHfu+vd32+CubGehSg7H6giREHDvsIUyIFJY0b4gC81w9uxY7r
pbWEnykBV69sGKi4loWT6cEZQQIDAQABo1MwUTAdBgNVHQ4EFgQULUTCsErmX3uL
X4rhODwI7gLzq7IwHwYDVR0jBBgwFoAULUTCsErmX3uLX4rhODwI7gLzq7IwDwYD
VR0TAQH/BAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAgEANpSsd1Xcn4eQq7rVu0Bh
KQwOPlzboU2p5cyluVLzTRrl4IDKerzCERmYnjr4/ujI55teTbofNdFN6YW99cxm
lbQ8dfqSNBIU+DmtwLVXCRmHFdAUVKNp+0Br6BSW7lcxdi6XLId5aOpVzt0KXsND
UYVkQRhfOodn+rkMCgeWxzjF4c28tYrc7a5a+7pLNHnQRn35Wo0xCxgYnz/ALTZo
WDyPROI0EFPBxO3MrOpsN+A0+wQZ3xZ8kQAwSTkKCt1xL/JpTGH5rM6DJT1CktIF
20t0onNLSz4afJufOWYplAUo+G/vyDqhsQ5VZ1RAiTMsAkzALUqQnwaYK2n+46g9
nLscqXeTqFFrJfdjJuSglixycVlqYjK0L+2NZK18yN2TYmfsnJlwq1ucb8hlr5TG
ux77tW/Hwa/wNNzMHjKHh4zWlPU4TgLqhAoBBmqIBGNEryT1C1biH21XIJJcAoTo
atE92yFj+kMa30S3cUX4IfXf6wRVzb3GwjzRRkVTpoAr69a94FW3tHywu4iBDFGA
N+w2PPPI1xkBgjbn6sh8iaYHe08/PfW7tKn1m9amgxZnkGFEO+6gZZDmZByX5oXw
WN0HIZ4QB7LiM3RI03n4TZFzh1jWsNeN7RQ3gsShSpSMq3lVHHZ77ombQ/asipaC
msIeHOtBEai6PiW9ZuyI+Kw=
-----END CERTIFICATE-----`;
const cert = `-----BEGIN CERTIFICATE-----
MIIEkDCCAnigAwIBAgIURNN9wbyVH9ZFqrv5TzS4Na0P4qUwDQYJKoZIhvcNAQEL
BQAwTjELMAkGA1UEBhMCVUsxDzANBgNVBAgMBkxvbmRvbjEVMBMGA1UECgwMVGhh
bGFtb3MgTHRkMRcwFQYDVQQDDA50aGFsYW1vcy5jby51azAgFw0yNTAyMjQxNTMz
NTVaGA8yMDUyMDcxMTE1MzM1NVowcDELMAkGA1UEBhMCVUsxDzANBgNVBAgMBkxv
bmRvbjEPMA0GA1UEBwwGTG9uZG9uMREwDwYDVQQKDAhUaGFsYW1vczEsMCoGA1UE
AwwjYnJhemlsLWNsaWVudC5kZXYudGhhbGFtb3NhcHAuY28udWswggEiMA0GCSqG
SIb3DQEBAQUAA4IBDwAwggEKAoIBAQC1aB+DBq0P7siJcqMnhiVN6mshHtmisIQu
Gw+SO40lUfj9lTg5OD8+fKvDOw1p5kNNEF2FRry2y2bkdjCId8/4A+/AWR78A4ba
nlEhb+NmsP+cj/a4anovO3oIeDJlkjAZYIZkP5isT68Tz+YxnEAC4FkaAAZiGiy4
h0w2SwrB2cp/mmazRflYORuS5olIcOohUHlzLLHNXot0Pf6yK2BgH2P7oWvcJMrU
3hJe2OhCoHmA4lxdqDeR8EKca2SkJ5Jyh5Qj4gSm87QByvpZ2qyviZmm5B4nax4n
rp6wSTLiI80zUtXXx8OfMq7HfmpPugN/hwKWxWxOpT8SAdjpwpwdAgMBAAGjQjBA
MB0GA1UdDgQWBBQOUK0G3R22iPl2BqfDK40E5Ydz2TAfBgNVHSMEGDAWgBQtRMKw
SuZfe4tfiuE4PAjuAvOrsjANBgkqhkiG9w0BAQsFAAOCAgEAkwOb+KxK+VteJKW4
tGjK/3ZRA4fdfjjALLslmmturpNMooSX9Q+4KLQ+12YL0d58IK2f7OjBz6w/dTwj
jZWJOkS3OiyRCFc2ppUJ8V53a+htIlpri4xn6NkljMDSlkDmX+0obMX/BfKg224g
TsHvJBUg9pN1sLvHxSlg19LDhvrDJABQnJsITFP23XSupf66U4xmHusGgBGII9vk
oINHXMWU9c9+4rk2zlXfE8A7QNwFlI1yGIph1GpKKvFglFQUHfXs+yrQdPV1xKzo
NGMzGUUCDzMZhwrwARgpPlmnmMedAi/AszYEqy80jpSQoJMezcbHXZ5LCwW0KiMV
wo3yslW3L7FLtdurLzldpO4vlkilzUZMJZ1g8bLzUV6j/+qL+xUj/PQ3A98bBvcE
EvOLIoqpbseogsvNAchVr+FmaCtR28/Zd0yrBTR5v7Y0XWtNuCARxbsOgf7Du6MD
FfA/P8Hx7PQhB33LMoPuWyNBTmTKOVxdM0qj3O6k+sJi98zl4tQ7mnDF7qaA8AqA
dsarhrMz7Su6FunPko4VEaa3wXaS6v7tqSGiTBMpmSMcRGM/zN8BRvejcZ4pnUDq
qzgUlmq0TmyndUllXwkhF7v+LLjEm25/MrMDb7RfMzfJJxrpQNwmLWrsrcqsJlXI
em34NTmTb7EmTfrAMpnG1shdoTg=
-----END CERTIFICATE-----`;
const key = `-----BEGIN PRIVATE KEY-----
MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC1aB+DBq0P7siJ
cqMnhiVN6mshHtmisIQuGw+SO40lUfj9lTg5OD8+fKvDOw1p5kNNEF2FRry2y2bk
djCId8/4A+/AWR78A4banlEhb+NmsP+cj/a4anovO3oIeDJlkjAZYIZkP5isT68T
z+YxnEAC4FkaAAZiGiy4h0w2SwrB2cp/mmazRflYORuS5olIcOohUHlzLLHNXot0
Pf6yK2BgH2P7oWvcJMrU3hJe2OhCoHmA4lxdqDeR8EKca2SkJ5Jyh5Qj4gSm87QB
yvpZ2qyviZmm5B4nax4nrp6wSTLiI80zUtXXx8OfMq7HfmpPugN/hwKWxWxOpT8S
AdjpwpwdAgMBAAECggEAEYf5/6IeCHulkq7q+I9cvI5qgv1lv/S6GXCRDStHJTOq
UethTxpR9lp7CPeEgNb5axGpUA95flri2zJW12FozkmnGloihe1bU3ZYVdhnzA1P
7pP1HnZfz3+6d+YRzMIXduReqIKC4SgkPdBqKSI2B3Eh+0LEWye3aa/dnCOdawVU
6ChQj6RloWwZxm3rGIz/yGyNymjypr7b9Fj/LDLIw0QOWPw0yyhoEGdcESRLzxkG
2DljOYK4fhJ/O3A+RlnUrLCG2vXVpN52JHA2BBAj9Ox0JwHOqU9zDs/dSBS7wvqQ
/lEbhsgFDgSmv03Ov6HwG77MYXfhvv8aV17NrOIzCwKBgQDohpxPSUQkPDxhCDa3
j1/C0T//ZcdXsP2iruiGDZ+CnKRvNb6Vp3KHGmTksFlk/7ZLYtycY+79mk+tOKIa
QietA6cipzYYH/SA39jtAxjg4ftHVXxOkP1ZGsJprFvfkKIDwdNzvVEj43cgm9xW
rZKw27jEKp3BUPvIb7Dfz/Q3UwKBgQDHuGR3ac6HSbaNNaKkK7wTgpNjcFWbHlvU
FnBE1i8QRC9TZP9H+TCmHkspViAVSGskd4sY9tXx2KAllzjCoOOKYuJSLqdAT0s6
sffF/I2xpgyM09eqmTvGiRNpI52fpJjjVkp1pqNVyI7CX+oFq7SUuBmpldZqQ19R
ytTck7KgzwKBgGqiqPZ3bCeN9EavhKBjwQ/P9KCEpYmion7D5eDsSHWWrpZNuGxb
UVuCEDkMYsK9vnUODowuDEEDTnzrFvQh2J4wqaprspQXu4KKpan0HKmtGRaarpo9
ReJiMjxSDgQWCSbd8cIHVTm3LD+pGsApc7dl3HMh9Bzerck654uMi7v/AoGAebVy
9Bp0k5lmOBORc757NOCD9TtFz+vmRg8Oh8SGlcEXnhiUQUYoUXNwllY34wBo2qZH
DAWQR3udzIqlOmZVg8XS6gYoQlaQH8rIlczchIAOcdu/N+V9ufVa8N2Vdu4VhaTW
Z3APZX19EhLlSGNk/qRabzAypDs+YVfb9DfFyZ0CgYAutSQdoRMSrov74nNSkDUq
5jpRBjepaHmD9SKAtui0ezDwTMPGbHSOAnOYhYiJbAFbakb/S4rdw42TexdEaIvJ
4Z0Qpmcjk3hdKDlh8Rh9GZQVQqNOPX6WIJr/mfYcMTHmMAXdq/nae06S43xzKZI/
gVF6oyGpc+75beQcaMgYsQ==
-----END PRIVATE KEY-----`;
export const brazilNorthTrust = {
    id: "641336c6-fa4e-46bd-850a-f39120ae0daa",
    systemName: "North Trust",
    externalSystemName: "Brazil North Trust",
    apiKey: "MOCK_API_KEY",
    hmacSha512SecretKey: "TODO HMAC KEY",
};
export const brazilSouthTrust = {
    id: "d6df0fab-c22c-46e9-93bf-cd3b1d3c0edb",
    systemName: "South Trust",
    externalSystemName: "Brazil South Trust",
    apiKey: "MOCK_API_KEY2",
    hmacSha512SecretKey: "TODO HMAC KEY2",
};
export const documentId = "d851c52f-a692-4efb-99af-b33a74ada226";
export const brazilTppInstance = {
    id: "a3f1c8e2-7b4d-4e6a-9c0f-2d8b5e1a3f7c",
    systemName: "Leading Edge TPP",
    displayName: "Brazil TPP SystmOne",
    aes128Key: "F28BCA50E5436A2CF6FB40BAAF7BC63A",
    aes128Iv: "76063CABD2FC25D3434FBDFF2C0112E2",
    odsCode: "RXA",
};
export const defaultTppInstances = [
    {
        instanceId: brazilTppInstance.id,
        displayName: brazilTppInstance.displayName,
        systemName: brazilTppInstance.systemName,
        aes128Key: brazilTppInstance.aes128Key,
        aes128Iv: brazilTppInstance.aes128Iv,
        odsCode: brazilTppInstance.odsCode,
        // On by default for seeded instances so the remembered-login flow can be
        // exercised end-to-end in dev/demo without first toggling it in admin.
        rememberLoginEnabled: true,
    },
];
export const brazilGenericInstance = {
    id: "b7e2d4f0-1c3a-4b5e-8d9f-6a0c2e4b8d1f",
    systemName: "Leading Edge Generic",
    displayName: "Brazil Generic EPR",
    apiKey: "MOCK_GENERIC_API_KEY",
    hmacSha512SecretKey: "MOCK_GENERIC_HMAC_SECRET_KEY",
    odsCode: "RXA",
    launchUrl: "http://aspire.local.thalamosapp.co.uk:3000",
};
export const defaultGenericInstances = [
    {
        instanceId: brazilGenericInstance.id,
        displayName: brazilGenericInstance.displayName,
        systemName: brazilGenericInstance.systemName,
        apiKey: brazilGenericInstance.apiKey,
        hmacSha512SecretKey: brazilGenericInstance.hmacSha512SecretKey,
        odsCode: brazilGenericInstance.odsCode,
        launchUrl: brazilGenericInstance.launchUrl,
        demographicsSource: "pds",
        // On by default for seeded instances so the remembered-login flow can be
        // exercised end-to-end in dev/demo without first toggling it in admin.
        rememberLoginEnabled: true,
    },
];
export const defaultEprs = [
    {
        instanceId: brazilNorthTrust.id,
        displayName: brazilNorthTrust.externalSystemName,
        // On by default for seeded instances so the remembered-login flow can be
        // exercised end-to-end in dev/demo without first toggling it in admin.
        rememberLoginEnabled: true,
        conexesConfiguration: {
            authentication: {
                userId: "North User",
                systemName: brazilNorthTrust.systemName,
                url: "https://brazil.local.thalamosapp.co.uk:5002/api/ApiServiceV4.svc",
                certificates: {
                    cert,
                    ca,
                    key,
                    expectedServerCommonName: null,
                },
            },
            documentType: "CL",
        },
        clickthrough: {
            hmacSha512SecretKey: brazilNorthTrust.hmacSha512SecretKey,
            apiKey: brazilNorthTrust.apiKey,
            launchUrl: "http://aspire.local.thalamosapp.co.uk:3000",
        },
    },
    {
        instanceId: brazilSouthTrust.id,
        displayName: brazilSouthTrust.externalSystemName,
        // On by default for seeded instances so the remembered-login flow can be
        // exercised end-to-end in dev/demo without first toggling it in admin.
        rememberLoginEnabled: true,
        conexesConfiguration: {
            authentication: {
                userId: "South User",
                systemName: brazilSouthTrust.systemName,
                url: "https://brazil.local.thalamosapp.co.uk:5002/api/ApiServiceV4.svc",
                certificates: {
                    cert,
                    ca,
                    key,
                    expectedServerCommonName: null,
                },
            },
            documentType: "CL",
        },
        clickthrough: {
            hmacSha512SecretKey: brazilSouthTrust.hmacSha512SecretKey,
            apiKey: brazilSouthTrust.apiKey,
            launchUrl: "http://aspire.local.thalamosapp.co.uk:3000",
        },
    },
];
//# sourceMappingURL=eprs.js.map